<template>
    <div class="mt-2">
        <div v-if="recipes.length" class="flex flex-col gap-2">
            <Link
                v-for="recipe in recipes.slice(0, count)"
                :key="recipe.id"
                :href="`/recipes/${recipe.slug}`"
                class="home-recipe-row group flex items-center gap-3 overflow-hidden rounded border border-slate-700/40 bg-slate-900/30"
            >
                <img
                    :ref="`img-${recipe.id}`"
                    class="h-14 w-14 flex-shrink-0 object-cover transition-transform duration-500 group-hover:scale-105"
                    :src="recipe.bg"
                    :alt="recipe.name"
                    @error="imageLoadError(recipe.id)"
                />
                <div class="min-w-0 flex-1 py-1 pr-2">
                    <h3
                        class="truncate text-sm font-semibold leading-tight text-slate-100 group-hover:text-yellow-200"
                    >
                        {{ recipe.name }}
                    </h3>
                    <p class="text-xs leading-tight text-slate-400">
                        {{ formatDate(recipe.created_at, 'MMM D, YYYY') }}
                    </p>
                </div>
            </Link>
        </div>
        <div
            v-else
            class="flex h-24 w-full flex-wrap items-center justify-center text-center text-slate-400"
        >
            No Recipes Yet.
        </div>
    </div>
</template>

<script>
import { formatDate } from '@/utils/Utilities';
import { Link } from '@inertiajs/vue3';
import { gsap } from 'gsap/all';

export default {
    name: 'HomeLatestRecipes',
    components: { Link },
    props: {
        recipes: {
            type: Array,
            default: () => [],
        },
        count: {
            type: Number,
            default: 5,
        },
    },
    mounted() {
        gsap.fromTo(
            '.home-recipe-row',
            { y: 10, opacity: 0 },
            { y: 0, opacity: 1, stagger: 0.03, duration: 0.25 },
        );
    },
    methods: {
        formatDate,
        imageLoadError(id) {
            const im = this.$refs[`img-${id}`];
            if (im && im[0]) {
                im[0].src = '/images/recipes/nopic.svg';
            }
        },
    },
};
</script>

<style lang="postcss">
.home-recipe-row {
    opacity: 0;
}
</style>
